'use client';

import React from 'react';
import { Button } from './Button';
import WhatsappIcon from '@/icons/WhatsappIcon';

export default function WhatsappCTAButton({ className }: { className?: string }) {
  return (
    <Button
      component="a"
      href="https://wa.me/5548991939567?text=Ol%C3%A1%2C%20tudo%20bem%3F%20Vim%20atrav%C3%A9s%20do%20Site%20e%20preciso%20tirar%20uma%20d%C3%BAvida."
      target="_blank"
      variant="default"
      size="sm"
      icon={<WhatsappIcon />}
      className={['flex justify-center', className || ''].join(' ')}
    >
      PRECISO DE UM ADVOGADO
    </Button>
  );
}
